export default __webpack_public_path__ + "static/media/loader-logo-circle.798cbca1.png";